import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import { getHomePathForUser } from './utils/roles';

const Dashboard = React.lazy(() => import('./components/Dashboard'));

const AppLoading = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <p>Loading...</p>
  </div>
);

const AppContent = () => {
  const { isAuthenticated, isLoading, login, user } = useAuth();

  if (isLoading) {
    return <AppLoading />;
  }

  return (
    <Suspense fallback={<AppLoading />}>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated() ? (
              <Navigate to={getHomePathForUser(user)} replace />
            ) : (
              <Login onLogin={login} />
            )
          }
        />
        <Route
          path="/*"
          element={isAuthenticated() ? <Dashboard /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </Suspense>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
